import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/menu-digital/MenuObjetivoClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/schema/FAQSchema.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/schema/ServiceSchema.tsx");
